import { Trans, useTranslation } from 'react-i18next';
import Breadcrumb from '../../../components/common/Breadcrumb/Breadcrumb';
import ButtonIconOutlineMedium from '../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import ButtonPrimaryMedium from '../../../components/common/ButtonPrimary/ButtonPrimaryMedium';
import { Icon } from '../../../components/icon/icon';
import HeaderCMS from '../../../components/layout/HeaderCMS/HeaderCMS';
import ButtonSecondaryMedium from '../../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import { Divider } from 'antd';
import { useEffect, useState } from 'react';
import { Flex } from 'antd';
import { Steps } from 'antd';
import { Input } from 'antd';
import ButtonIconOutlineSmall from '../../../components/common/ButtonIconOutline/ButtonIconOutlineSmall';
import DropdownComponent from '../../../components/common/DropdownComponent/DropdownComponent';
import Tag from '../../../components/common/Tag/Tag';
import ButtonIconGhostSmall from '../../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import ButtonLink from '../../../components/common/ButtonLink/ButtonLink';
import { Empty } from 'antd';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchOrderAdmin,
  remindPayment,
  updateOrderAdmin,
} from '../../../store/actions/admin.room.action';
import RenderFulfillmentHistoryStatusTag from '../../../components/common/Tag/RenderFulfillmentHistoryStatus';
import RenderPaymentStatusTag from '../../../components/common/Tag/RenderPaymentStatus';
import formatDateTime from '../../../utils/dayjs/formatDateTime.util';
import { useNavigate } from 'react-router-dom';
import { cn } from '../../../utils/string/cn.utils';
import ButtonSecondarySmall from '../../../components/common/ButtonSecondary/ButtonSecondarySmall';
import useModalAddress from '../../../components/common/ModalAddress/ModalAddress';
import ButtonPrimarySmall from '../../../components/common/ButtonPrimary/ButtonPrimarySmall';
import { Form } from 'antd';
import DatePickerComponent from '../../../components/common/DatePickerComponent/DatePickerComponent';
import dayjs from 'dayjs';
import { openMessageSuccess } from '../../../components/common/Message/openMessageSuccess';
import { Spin } from 'antd';
import { openMessageError } from '../../../components/common/Message/openMessageError';
import ROUTER from '../../../routers/Routers';
import { STATUS_OPTIONS } from '../../../constants/constant';
import DrawerDetailModule from '../../CartPage/components/DrawerDetailModule/DrawerDetailModule';
import { Avatar } from 'antd';
import openModalRefundInformation from '../../../components/common/Modal/openModalRefundInformation';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { parseJson } from '../../../utils/string/parseJson';
import { useExportExcel } from '../../../hooks/useExportExcel';
import {
  convertCostDataToExcel,
  convertCostMultiDataToExcel,
} from '../../../services/Excel/ConvertToExcel';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const DetailOrderPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { order } = useSelector(state => state.adminRoom);
  const [deliveryAddress, setDeliveryAddress] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { exportToExcel } = useExportExcel();

  const [form] = Form.useForm();

  const watchPaidStep = Form.useWatch('paid_step', form);

  const [encodedAddress, setEncodedAddress] = useState();
  const [statusItems, setStatusItems] = useState();

  const { getFullAddress } = useModalAddress({
    handleUpdateAddress: addressId => {},
  });

  const renderCardItems = () => {
    try {
      const items = parseJson(order.detail?.items ?? '[]');
      return (
        <>
          {items?.map((item, index) => (
            <CardItem key={index} item={item} />
          ))}
        </>
      );
    } catch (error) {
      return <Empty />;
    }
  };

  const renderCoupons = () => {
    if (order.detail?.coupon_codes === undefined) return;
    const couponList = parseJson(order.detail?.coupon_codes);
    let totalCoupon = 0;
    return (
      <>
        {couponList
          ?.filter(item => item.result)
          ?.map((coupon, index) => {
            totalCoupon += coupon.amount;
            return (
              <Tag
                key={index}
                className="bg-[#E3EFFB] text-[#145B90] items-center flex gap-[4px] px-[8px] py-[4px] rounded-[4px]"
                label={
                  <>
                    <span className="flex w-[16px] h-[16px]">
                      <Icon.ICVoucher />
                    </span>
                    <span className="text-label-medium font-semibold">
                      {coupon.code}
                    </span>
                  </>
                }
              />
            );
          })}
        <span className="text-body-medium font-semibold">
          -{convertForeignCurrency(order.detail?.discount)}
        </span>
      </>
    );
  };

  const checkMethodPayment = key => {
    // if (['QR'].includes(key)) return 'Pay via QR code';
    // if (['VISA', 'MASTERCARD', 'JCB'].includes(key)) return 'Credit/Debit Card';
    // return 'Domestic ATM card';
    if (['MC'].some(item => key?.includes(item))) return 'Credit/Debit Card';
    if (['VC'].some(item => key?.includes(item))) return 'Credit/Debit Card';
    if (['9704'].some(item => key?.includes(item))) return 'Domestic ATM card';
    return 'Pay via QR code';
  };

  const renderPaymentTransaction = () => {
    const paymentList = (() => {
      try {
        return parseJson(order.detail?.payment_transactions ?? '[]');
      } catch (error) {
        return order.detail?.payment_transactions;
      }
    })();

    let transactions = [];
    order.detail?.payment_installments?.forEach((item, index) => {
      const transaction = paymentList[index];
      const firstIndexPendingInstallment =
        order.detail?.payment_installments?.findIndex(
          item => item.status === 'pending'
        );

      transactions.push(
        <CardTransaction
          key={index}
          title={
            index === 0
              ? t('1st Installment')
              : index === 1
                ? t('2nd Installment')
                : index === 2
                  ? t('3rd Installment')
                  : t('{x}th Installment', { x: index + 1 })
          }
          tag={
            item.status === 'paid' ? (
              <Tag
                className={
                  'flex py-[4px] px-[6px] items-center gap-[6px] rounded-[1000px] bg-[#49AC3E]'
                }
                label={
                  <span className="text-label-medium font-semibold text-white">
                    {t('Completed payment')}
                  </span>
                }
              />
            ) : (
              <Tag
                className={
                  'flex py-[4px] px-[8px] items-center gap-[6px] rounded-[1000px] bg-[#F97D16]'
                }
                label={
                  <span className="text-label-medium font-semibold text-white">
                    {t('Pending payment')}
                  </span>
                }
              />
            )
          }
          isRemind={item.is_reminded && item.status === 'pending'}
          amount={convertForeignCurrency(item?.amount)}
          paid={
            !(
              item.status !== 'pending' ||
              firstIndexPendingInstallment === index
            ) || item.status === 'paid'
          }
          paidDate={
            formatDateTime(
              item.paid_at ??
                (item.status === 'paid' ? transaction?.created_at : null),
              'dateFormat.dateTime'
            ) || null
          }
          methodPayment={checkMethodPayment(
            transaction?.raw_response?.vpc_Card
          )}
        />
      );
    });
    return (
      <>
        {transactions.length ? (
          transactions
        ) : (
          <div className="flex items-center justify-center self-stretch grow">
            <Empty />
          </div>
        )}
      </>
    );
  };
  const countCoupons = () => {
    if (order.detail?.coupon_codes === undefined) return 0;
    const couponList = parseJson(order.detail?.coupon_codes);
    let totalCoupon = 0;
    couponList.forEach(coupon => {
      totalCoupon += coupon.amount;
    });
    return totalCoupon;
  };

  const loadAddress = async () => {
    try {
      if (order.detail?.bill_address_info) {
        const fullAddress = await getFullAddress({
          wardId: order.detail?.bill_address_info?.ward,
          provinceId: order.detail?.bill_address_info?.city,
        });
        const address =
          order.detail?.bill_address_info?.street + ', ' + fullAddress;
        if (address) {
          setDeliveryAddress(address);
          setEncodedAddress(encodeURIComponent(address));
        }
      }
    } catch (error) {
      console.log('Cant load Address');
    }
  };

  const renderFulfillmentStatus = (orderType, status) => {
    switch (status) {
      case 0:
        return t('Create order');
      case 1:
        return t('Confirm order');
      case 2:
        return t('In production');
      case 3:
        return t('Pack & ready for delivery');
      case 4:
        return t('Transport');
      case 5:
        return t('Delivery');
      case 6:
        return orderType === 2 ? t('Install') : t('Construction');
      case 7:
        return t('Handed over');
      default:
        return t('Cancel order');
    }
  };

  const renderPaymentStatus = (step, orderType) => {
    switch (step) {
      case 0:
        return t('Pending payment');
      case 1:
        return t('Paid first time');
      case 2:
        return t('Paid second time');
      case 3:
        return orderType === 1 ? t('Completed payment') : t('Paid last time');
    }
  };

  const applyStatusToSteps = (arr, { title, status, description }) => {
    arr.push({
      title: (
        <span className="text-title-small font-semibold text-black/60">
          {title}
        </span>
      ),
      description: <span className="text-body-small">{description}</span>,
      status,
    });
  };

  useEffect(() => {
    const length = order.detail?.fulfillment_history_status?.length;
    const status = order.detail?.fulfillment_history_status?.[length - 1]?.[0];
    form.setFieldsValue({
      ...(order.detail ?? {}),
      estimated_delivery_date: order.detail?.estimated_delivery_date
        ? dayjs(order.detail?.estimated_delivery_date)
        : null,
    });
    if (order.detail) {
      const total =
        (order.detail?.amount ?? 0) +
        (order.detail?.shipping_fee ?? 0) -
        (order.detail?.discount ?? 0);
      // setAmountPay({
      //   total,
      //   total1: total * 0.5,
      //   total2: total * 0.3,
      //   total3: total * 0.2,
      // });

      // const history = order.detail.fulfillment_history_status;
      // const timeline = order.detail.timeline ?? [];
      // const tempStatusItems = analyzeTimeline(history, timeline);
      // setStatusItems(tempStatusItems);
    }
  }, [order.detail]);

  useEffect(() => {
    if (id) {
      //dispatch action get order detail by id
      dispatch(fetchOrderAdmin({ id })).then(action => {
        if (!action.payload?.data) {
          openMessageError({ content: t('Cannot load') });
        }
      });
    }
  }, [id]);

  useEffect(() => {
    loadAddress();
  }, [order.detail?.bill_address_info]);

  return (
    <>
      <Spin fullscreen spinning={order.isLoading} />
      <Form form={form} layout="vertical">
        <HeaderCMS
          className="relative top-0 left-0 right-0"
          breadcrumb={
            <div className="flex items-center gap-[16px]">
              <ButtonIconOutlineMedium
                icon={<Icon.ICArrowBack />}
                onClick={() => navigate(ROUTER.CMS + ROUTER.ORDER)}
              />
              <Breadcrumb
                items={[
                  {
                    title: (
                      <span className="text-label-large font-semibold text-black/30 select-none h-[20px]">
                        {t('All orders')}
                      </span>
                    ),
                  },
                  {
                    title: (
                      <span className="text-label-large font-semibold text-black/60 cursor-pointer h-[20px]">
                        {t('Order details')}
                      </span>
                    ),
                  },
                ]}
              />
            </div>
          }
          actions={
            <div className="flex items-center gap-[16px]">
              <ButtonSecondaryMedium
                title={t('Cancel order2')}
                posIcon={<Icon.ICDelete />}
                className={'warning'}
                disabled={[8, 7].includes(order.detail?.fulfillment_status)}
                onClick={() => {
                  dispatch(
                    updateOrderAdmin({
                      id: order.detail?.id,
                      fulfillment_status: 8,
                    })
                  ).then(action => {
                    if (action.payload?.data) {
                      openMessageSuccess({ content: t('Successfully') });
                    }
                  });
                }}
              />
              {order.detail?.fulfillment_status === 0 ? (
                <ButtonSecondaryMedium
                  title={t('Confirm order')}
                  className={'warning'}
                  disabled={[8, 7].includes(order.detail?.fulfillment_status)}
                  onClick={() => {
                    const data = { id: order.detail?.id };
                    data.fulfillment_status = 1;

                    dispatch(updateOrderAdmin(data)).then(action => {
                      if (action.payload?.data) {
                        openMessageSuccess({
                          content: t('Successfully'),
                        });
                      }
                    });
                  }}
                />
              ) : null}

              {order.detail?.fulfillment_status === 8 ? (
                <ButtonSecondaryMedium
                  title={t('Update refund')}
                  posIcon={<Icon.ICReceipt />}
                  onClick={() => {
                    if (order.detail) openModalRefundInformation(order.detail);
                    else openMessageError(t('Error.unknown_error'));
                  }}
                />
              ) : (
                <></>
              )}

              <ButtonSecondaryMedium
                title={t('Print invoices')}
                posIcon={<Icon.ICPrint />}
              />
              <ButtonSecondaryMedium
                title={t('Download quote')}
                className="text-[#258FD2]"
                onClick={() => {
                  try {
                    const products = JSON.parse(order?.detail?.items);
                    const dataExcels = products
                      .map(product => {
                        const priceInfo = JSON.parse(product.price_info);
                        const country_code = priceInfo.country_code ?? 'vn';
                        return (
                          priceInfo?.dataExcel?.[country_code] ??
                          priceInfo?.costPersistable?.[country_code]?.registry
                        );
                      })
                      .filter(Boolean);
                    const data = convertCostMultiDataToExcel(dataExcels);
                    if (data)
                      exportToExcel(
                        data,
                        `${order.detail?.name_owner ?? ''}_${order.detail?.code}_BG_${country_code}`
                      );
                  } catch (error) {
                    console.log(error);
                  }
                  // const result = json.dataExcel;
                  // if (result) exportToExcel(result, item.item_name ?? '');
                }}
              />
              <ButtonPrimaryMedium
                title={t('Save changes')}
                posIcon={<Icon.ICSave />}
                // disabled={[8, 7].includes(order.detail?.fulfillment_status)}
                onClick={() => {
                  const values = form.getFieldsValue();
                  const estimatedDeliveryDate = values.estimated_delivery_date
                    ? dayjs(values.estimated_delivery_date).format('YYYY-MM-DD')
                    : null;
                  const prevEstimatedDeliveryDate = order.detail
                    ?.estimated_delivery_date
                    ? dayjs(order.detail?.estimated_delivery_date).format(
                        'YYYY-MM-DD'
                      )
                    : null;
                  // const fulfillmentStatus = values.fulfillment_status;
                  const paidStep = values.paid_step;
                  const note = values.note;

                  const data = { id: order.detail?.id };

                  if (estimatedDeliveryDate !== prevEstimatedDeliveryDate) {
                    data.estimated_delivery_date = estimatedDeliveryDate;
                  }
                  // if (fulfillmentStatus !== order.detail?.fulfillment_status) {
                  //   data.fulfillment_status = fulfillmentStatus;
                  // }
                  if (paidStep !== order.detail?.paid_step) {
                    data.paid_step = paidStep;
                  }
                  if (note !== order.detail?.note) {
                    data.note = note;
                  }

                  dispatch(updateOrderAdmin(data)).then(action => {
                    if (action.payload?.data) {
                      openMessageSuccess({ content: t('Successfully') });
                    }
                  });
                }}
              />
            </div>
          }
        />
        <section className="flex p-[16px] flex-col justify-start items-start gap-[16px] self-stretch h-screen overflow-auto z-0">
          <div className="flex self-stretch items-center justify-center">
            <div className="flex max-w-[1124px] justify-center items-start gap-[16px] grow">
              {/* Left Column */}
              <div className="flex flex-col items-start gap-[16px] grow">
                <div className="flex p-[24px] flex-col items-start gap-[16px] self-stretch rounded-[16px] bg-fills-white">
                  <span className="text-title-large !font-bold">
                    {order.detail?.code}
                  </span>
                  <Divider type="horizontal" className="!p-0 m-0" />
                  <div className="flex items-start gap-[12px] self-stretch">
                    <div className="flex flex-col justify-center items-start gap-[8px] grow">
                      <span className="text-body-medium font-semibold">
                        {t('Order date')}
                      </span>
                      <span className="text-body-medium">
                        {formatDateTime(order.detail?.created_at)}
                      </span>
                    </div>
                    <div className="flex flex-col justify-center items-start gap-[8px] grow">
                      <span className="text-body-medium font-semibold">
                        {t('Status')}
                      </span>
                      <span className="text-body-medium">
                        {(() => {
                          const listStatus = [0, 1];
                          order.detail?.timeline?.forEach((item, index) => {
                            if (item) {
                              listStatus.push(index + 2);
                            }
                          });
                          const len =
                            order.detail?.fulfillment_history_status?.length;
                          const status =
                            order.detail?.fulfillment_history_status?.[
                              len - 1
                            ]?.[0];
                          const indexStatus = listStatus.findIndex(
                            item => item === status
                          );
                          return (
                            <RenderFulfillmentHistoryStatusTag
                              status={listStatus[indexStatus + 1] ?? 6}
                              className={'cursor-pointer'}
                            />
                          );
                        })()}
                      </span>
                    </div>
                    {/* <div className="flex flex-col justify-center items-start gap-[8px] grow">
                    <Form.Item
                      name={'fulfillment_status'}
                      label={
                        <span className="text-body-medium font-semibold text-black/80">
                          {t('Status')}
                        </span>
                      }
                    >
                      <DropdownComponent
                        className="justify-between text-black/80"
                        trigger={['click']}
                        disabled={
                          [8, 7].includes(order.detail?.fulfillment_status) ||
                          (order.detail?.order_type === 2 &&
                            order.detail?.fulfillment_status === 6)
                        }
                        menu={{
                          items: [
                            {
                              key: 1,
                              label: (
                                <div
                                  className={cn(
                                    'flex p-[8px] items-center gap-[8px] self-stretch rounded-[2px] hover:bg-[#F1F2F2] focus:bg-[#EDFAFF] w-[200px]'
                                  )}
                                >
                                  <span className="text-body-medium">
                                    {t(STATUS_OPTIONS[Number(order.detail?.order_type ?? 0) === 2 ? 4 : Number(order.detail?.order_type ?? 0) === 3 ? 3 : 2])}
                                  </span>
                                </div>
                              ),

                              onClick: () => {
                                form.setFieldValue('fulfillment_status', 1);
                              },
                            }
                          ],
                        }}
                      >
                        <RenderFulfillmentHistoryStatusTag
                          orderType={order.detail?.order_type}
                          status={watchFulfillmentStatus + 1}
                          className={'cursor-pointer'}
                        />
                      </DropdownComponent>
                    </Form.Item>
                  </div> */}
                    <div className="flex flex-col justify-center items-start gap-[8px] grow">
                      <Form.Item
                        name={'paid_step'}
                        label={
                          <span className="text-body-medium font-semibold text-black/80">
                            {t('Payment')}
                          </span>
                        }
                      >
                        <DropdownComponent
                          className="justify-between"
                          trigger={['click']}
                          disabled={[8, 7].includes(
                            order.detail?.fulfillment_status
                          )}
                          menu={{
                            items: [
                              ...(order.detail?.type === 1
                                ? [
                                    {
                                      key: 0,
                                      label: (
                                        <div className="flex p-[8px] items-center gap-[8px] self-stretch rounded-[2px] hover:bg-[#F1F2F2] focus:bg-[#EDFAFF]">
                                          <span className="text-body-medium">
                                            {renderPaymentStatus(0)}
                                          </span>
                                        </div>
                                      ),
                                      onClick: () => {
                                        form.setFieldValue('paid_step', 0);
                                      },
                                    },
                                    {
                                      key: 3,
                                      label: (
                                        <div className="flex p-[8px] items-center gap-[8px] self-stretch rounded-[2px] hover:bg-[#F1F2F2] focus:bg-[#EDFAFF]">
                                          <span className="text-body-medium">
                                            {renderPaymentStatus(
                                              3,
                                              order.detail?.type
                                            )}
                                          </span>
                                        </div>
                                      ),
                                      onClick: () => {
                                        form.setFieldValue('paid_step', 3);
                                      },
                                    },
                                  ]
                                : [
                                    ...Array.from({ length: 4 }, (_, i) => ({
                                      key: i,
                                      label: (
                                        <div className="flex p-[8px] items-center gap-[8px] self-stretch rounded-[2px] hover:bg-[#F1F2F2] focus:bg-[#EDFAFF]">
                                          <span className="text-body-medium">
                                            {renderPaymentStatus(i)}
                                          </span>
                                        </div>
                                      ),
                                      onClick: () => {
                                        form.setFieldValue('paid_step', i);
                                      },
                                    })),
                                  ]),
                              //  ( ...Array.from({ length: 4 }, (_, i) => ({
                              //     key: i,
                              //     label: (
                              //       <div className="flex p-[8px] items-center gap-[8px] self-stretch rounded-[2px] hover:bg-[#F1F2F2] focus:bg-[#EDFAFF]">
                              //         <span className="text-body-medium">
                              //           {renderPaymentStatus(i)}
                              //         </span>
                              //       </div>
                              //     ),
                              //     onClick: () => {
                              //       form.setFieldValue('paid_step', i);
                              //     },
                              //   })))
                            ],
                          }}
                        >
                          <RenderPaymentStatusTag
                            step={watchPaidStep}
                            className={'cursor-pointer'}
                          />
                        </DropdownComponent>
                      </Form.Item>
                    </div>
                    <div className="flex flex-col justify-center items-start gap-[8px] grow">
                      <Form.Item
                        label={
                          <span className="text-body-medium font-semibold text-black/80">
                            {t('Expected delivery date')}
                          </span>
                        }
                        name={'estimated_delivery_date'}
                      >
                        <DatePickerComponent
                          placeholder={t('Expected delivery date')}
                          style={{ display: 'flex', flex: '1 0 0' }}
                          disabled={[8, 7].includes(
                            order.detail?.fulfillment_status
                          )}
                          classNames={{
                            root: 'py-[6px] px-[8px] h-[30px] flex items-center flex-row-reverse text-label-medium font-semibold text-black/80',
                          }}
                          minDate={dayjs()}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="flex p-[24px] flex-col items-start gap-[16px] self-stretch rounded-[16px] bg-fills-white">
                  <Form.Item
                    name={'note'}
                    label={
                      <span className="text-title-medium !font-bold text-black/80">
                        {t('Note')}
                      </span>
                    }
                    className="flex justify-between items-start self-stretch"
                  >
                    <Input.TextArea
                      // disabled={[8, 7].includes(order.detail?.fulfillment_status)}
                      rows={4}
                      placeholder={t('Note')}
                    />
                  </Form.Item>
                  {/* <div className="flex justify-between items-start self-stretch">
                <ButtonIconOutlineSmall icon={<Icon.ICEdit />} />
              </div> */}
                </div>
                <div className="flex p-[24px] flex-col items-start gap-[16px] self-stretch rounded-[16px] bg-fills-white">
                  <span className="text-title-medium !font-bold">
                    {t('Products')}
                  </span>
                  <Divider type="horizontal" className="!p-0 m-0" />
                  <div className="flex flex-col items-start gap-[4px] self-stretch">
                    {renderCardItems()}
                  </div>
                  <Divider type="horizontal" className="m-0 !p-0" />
                  <div className="flex py-[8px] flex-col items-start gap-[12px] self-stretch">
                    <div className="flex justify-between items-center self-stretch">
                      <span className="text-label-large font-semibold">
                        {t('Subtotal')}
                      </span>
                      <span className="text-body-medium font-semibold">
                        {convertForeignCurrency(
                          (order.detail?.amount ?? 0) -
                            (order.detail?.shipping_fee ?? 0) -
                            (order.detail?.discount ?? 0)
                        )}
                      </span>
                    </div>
                    <div className="flex justify-between items-center self-stretch">
                      <span className="text-label-large font-semibold">
                        {t('Discounts')}
                      </span>
                      <div className="flex items-center gap-[16px]">
                        {(() => {
                          try {
                            if (Array.isArray(order.detail?.coupon_codes)) {
                              return order.detail?.coupon_codes;
                            } else if (
                              typeof order.detail?.coupon_codes === 'string'
                            ) {
                              return JSON.parse(order.detail?.coupon_codes);
                            } else if (
                              typeof order.detail?.coupon_codes === 'string'
                            ) {
                              return JSON.parse(order.detail?.coupon_codes);
                            }
                          } catch (error) {
                            console.log(error);
                            return [];
                          }
                        })()
                          ?.filter(item => item.result)
                          ?.map(item => {
                            return (
                              <Tag
                                key={item.code}
                                label={
                                  <div className="flex items-center justify-center gap-[4px]">
                                    <span className="flex w-[16px] h-[16px]">
                                      <Icon.ICPercentDiscount />
                                    </span>
                                    <span className="text-label-medium">
                                      {(() => {
                                        if (item.discount_type === 'percent') {
                                          return t('{{x}}% Off', {
                                            x:
                                              item.discount_type === 'percent'
                                                ? `${item.discount_value || 0}`
                                                : `${convertForeignCurrency(item.discount_value)}`,
                                          });
                                        } else {
                                          return item.code;
                                        }
                                      })()}
                                    </span>
                                  </div>
                                }
                                className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                              />
                            );
                          })}

                        <span className="text-body-medium font-semibold">
                          -
                          {convertForeignCurrency(
                            Number(order.detail?.discount ?? 0)
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="flex justify-between items-center self-stretch">
                      <span className="text-label-large font-semibold">
                        {t('Shipping fee')}
                      </span>
                      <div className="flex items-center gap-[16px]">
                        {order.detail?.shipping_fee ? (
                          <span className="text-body-medium font-semibold">
                            {convertForeignCurrency(
                              order.detail?.shipping_fee ?? 0
                            )}
                          </span>
                        ) : (
                          t('Free')
                        )}
                      </div>
                    </div>
                  </div>
                  <Divider type="horizontal" className="m-0 !p-0" />
                  <div className="flex items-center gap-[10px] self-stretch justify-between">
                    <span className="text-label-large font-semibold">
                      {t('Total price')}
                    </span>
                    <span className="text-title-medium">
                      {convertForeignCurrency(order.detail?.amount)}
                    </span>
                  </div>
                </div>
                <div className="flex p-[24px] flex-col items-start gap-[16px] self-stretch rounded-[16px] bg-fills-white">
                  <div className="flex justify-start items-center self-stretch">
                    <span className="text-title-medium !font-bold">
                      {t('Payment information')}
                    </span>
                    {/* <Tag
                  label={
                    <span className="text-label-medium font-semibold text-white">
                      {t('Paid')}
                    </span>
                  }
                  className="py-[4px] px-[8px] justify-center items-center gap-[2px] rounded-[1000px] bg-[#49AC3E]"
                /> */}
                  </div>
                  <Divider type="horizontal" className="m-0 !p-0" />
                  {renderPaymentTransaction()}
                </div>
                <div className="inline-grid gap-x-[8px] self-stretch grid-cols-[fit-content(100%)_minmax(0,1fr)]">
                  <div className="flex w-[315px] p-[24px] items-start gap-[16px] flex-col self-stretch justify-self-start row-start-1 row-span-1 col-start-1 col-span-1 rounded-[16px] bg-fills-white">
                    <span className="text-title-medium !font-bold">
                      {t('Customer')}
                    </span>
                    <Divider type="horizontal" className="!p-0 m-0" />
                    <div className="flex flex-col items-start gap-[24px] self-stretch">
                      <div className="flex items-center gap-[8px]">
                        <div className="flex w-[48px] h-[48px] justify-center items-center rounded-[1000px] overflow-hidden">
                          <Avatar
                            size={48}
                            src={order?.detail?.user_avatar ?? ''}
                            icon={<Icon.ICUser />}
                          />
                        </div>
                        <div className="flex flex-col justify-center items-start">
                          <span className="text-label-large truncate text-black/60">
                            {order?.detail?.name_owner}
                          </span>
                          <span className="text-body-small text-black/30">
                            {`${order?.detail?.total_orders || 0} ${t('orders purchased')}`}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col items-start gap-[16px] self-stretch">
                        <div className="flex items-center gap-[8px] self-stretch">
                          <span className="flex w-[18px] h-[18px] justify-center items-center">
                            <Icon.ICMail />
                          </span>
                          <a
                            href={`mailto:${order?.detail?.email}`}
                            className="text-body-medium text-[#258FD2]"
                          >
                            {order?.detail?.email}
                          </a>
                        </div>
                        <div className="flex items-center gap-[8px] self-stretch">
                          <span className="flex w-[18px] h-[18px] justify-center items-center">
                            <Icon.ICPhone />
                          </span>
                          <a
                            href={`tel:${order?.detail?.phone}`}
                            className="text-body-medium text-[#258FD2]"
                          >
                            {order?.detail?.user_phone}
                          </a>
                        </div>
                        <div className="flex items-center gap-[8px] self-stretch">
                          <span className="flex w-[18px] h-[18px] justify-center items-center">
                            <Icon.ICLocation />
                          </span>
                          <span className="text-body-medium text-[#258FD2]">
                            {deliveryAddress ? (
                              <span className="text-body-medium text-black/60">
                                {`${deliveryAddress}`}
                              </span>
                            ) : (
                              <></>
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex p-[24px] flex-col items-start gap-[16px] grid-rows-1 grid-cols-1 justify-self-stretch bg-fills-white rounded-[16px]">
                    <span className="text-title-medium !font-bold">
                      {t('Delivery address')}
                    </span>
                    <Divider type="horizontal" className="!p-0 m-0" />
                    <div className="rounded-[8px] self-stretch h-[256px] overflow-hidden">
                      <iframe
                        width="100%"
                        height="400"
                        src={`https://www.google.com/maps?q=${encodedAddress}&output=embed`}
                        allowFullScreen
                      />
                    </div>
                    <div className="flex items-center gap-[8px] self-stretch">
                      <span className="flex w-[18px] h-[18px] justify-center items-center">
                        <Icon.ICLocation />
                      </span>
                      <span className="text-body-medium grow">
                        {deliveryAddress}
                      </span>
                      <ButtonIconOutlineSmall icon={<Icon.ICEdit />} />
                    </div>
                    <ButtonLink
                      className="text-[#258FD2]"
                      icon={<Icon.ICOpenNewTab />}
                      title={t('Open in Google Maps')}
                      onClick={() => {
                        window.open(
                          `https://www.google.com/maps?q=${encodedAddress}`
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="flex p-[24px] flex-col items-start gap-[16px] self-stretch rounded-[16px] bg-fills-white">
                  <div className="flex items-center justify-between self-stretch">
                    <span className="text-title-medium !font-bold">
                      {t('Delivery details')}
                    </span>
                    <ButtonPrimarySmall
                      title={t('Create shipment')}
                      disabled={[8, 7].includes(
                        order.detail?.fulfillment_status
                      )}
                      posIcon={<Icon.ICAddCircle />}
                    />
                  </div>
                  <Divider type="horizontal" className="!p-0 m-0" />
                  <div className="flex flex-col items-start justify-center self-stretch grow">
                    <div className="flex items-center justify-center self-stretch grow">
                      <Empty />
                    </div>
                  </div>
                </div>
              </div>
              {/* Right Column */}
              <div className="flex w-[280px] flex-col items-start gap-[8px] grow">
                <RenderTimeline />
              </div>
            </div>
          </div>
        </section>
      </Form>
    </>
  );
};

export default DetailOrderPage;

const RenderTimeline = () => {
  const { t } = useTranslation();
  const { order } = useSelector(state => state.adminRoom);
  const [statusItems, setStatusItems] = useState([]);

  const applyStatusToSteps = (arr, { title, status, description }) => {
    arr.push({
      title: (
        <span className="text-title-smallsmall font-semibold text-black/60">
          {t(title)}
        </span>
      ),
      description: <span className="text-body-small">{description}</span>,
      status,
    });
  };

  const analyzeTimeline = (history, timeline) => {
    const tempStatusItems = [];
    let desTaskCreate;
    let desTaskConfirm;
    if (history[0]) {
      desTaskCreate = history[0][1] ? `${history[0][1]}, ${history[0][2]}` : '';
    }
    if (history[1]) {
      desTaskConfirm = history[1][1]
        ? `${history[1][1]}, ${history[1][2]}`
        : '';
    }
    applyStatusToSteps(tempStatusItems, {
      title: STATUS_OPTIONS[0],
      description: desTaskCreate,
      status: history[0] ? 'finish' : 'process',
    });
    applyStatusToSteps(tempStatusItems, {
      title: STATUS_OPTIONS[1],
      description: desTaskConfirm,
      status: history[1] ? 'finish' : 'process',
    });

    timeline.forEach((item, index) => {
      if (item) {
        const historyCurrentStatus = history.find(
          item => item[0] === index + 2
        );
        const historyPreviousStatus = history.find(
          item => item[0] === index + 1
        );
        applyStatusToSteps(tempStatusItems, {
          title: STATUS_OPTIONS[index + 2],
          description: (
            <div className="flex flex-col items-start justify-start gap-[2px]">
              <span className="text-body-small">{item.startDatePlan}</span>
              <span className="text-body-small">{item.endDatePlan}</span>
            </div>
          ),
          status: historyCurrentStatus
            ? 'finish'
            : historyPreviousStatus
              ? 'process'
              : 'wait',
        });
      }
    });

    const listStatus = [0, 1];
    timeline.forEach((item, index) => {
      if (item) {
        listStatus.push(index + 2);
      }
    });
    const len = history.length;
    const status = history[len - 1]?.[0];
    const indexStatus = listStatus.findIndex(item => item === status);
    applyStatusToSteps(tempStatusItems, {
      title: STATUS_OPTIONS[6],
      description: '',
      status:
        indexStatus === listStatus.length - 1
          ? 'finish'
          : history[5]
            ? 'process'
            : 'wait',
    });
    return tempStatusItems;
  };

  useEffect(() => {
    const length = order.detail?.fulfillment_history_status?.length;
    const status = order.detail?.fulfillment_history_status?.[length - 1]?.[0];

    if (order.detail) {
      const total =
        (order.detail?.amount ?? 0) +
        (order.detail?.shipping_fee ?? 0) -
        (order.detail?.discount ?? 0);
      // setAmountPay({
      //   total,
      //   total1: total * 0.5,
      //   total2: total * 0.3,
      //   total3: total * 0.2,
      // });

      const history = order.detail.fulfillment_history_status;
      const timeline = order.detail.timeline ?? [];
      const tempStatusItems = analyzeTimeline(history, timeline);
      setStatusItems(tempStatusItems);
    }
  }, [order.detail]);

  return (
    <div className="flex p-[24px] flex-col items-start gap-[16px] rounded-[16px] self-stretch grow bg-fills-white">
      <span className="text-title-mediumedium !font-bold">{t('Status')}</span>
      <Divider type="horizontal" className="!p-0 m-0" />
      <span className="flex items-start self-stretch">
        {(() => {
          return (
            <Flex gap="middle" className="max-w-[250px]">
              <Steps
                progressDot={(_, info) => {
                  if (info.status === 'finish') {
                    return (
                      <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px] text-[#49AC3E]">
                        <Icon.ICCheckFill />
                      </span>
                    );
                  } else if (info.status === 'process') {
                    return (
                      <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                        <Icon.ICDot />
                      </span>
                    );
                  } else if (info.status === 'wait') {
                    return (
                      <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <circle
                            cx="8"
                            cy="8"
                            r="7"
                            fill="#EDEDED"
                            stroke="#EDEDED"
                            stroke-width="2"
                          />
                        </svg>
                      </span>
                    );
                  } else {
                    return (
                      <span className="flex w-[16px] h-[16px] absolute right-[-8px] top-[-4px]">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            d="M5.60016 11.334L8.00016 8.93398L10.4002 11.334L11.3335 10.4007L8.9335 8.00065L11.3335 5.60065L10.4002 4.66732L8.00016 7.06732L5.60016 4.66732L4.66683 5.60065L7.06683 8.00065L4.66683 10.4007L5.60016 11.334ZM8.00016 14.6673C7.07794 14.6673 6.21127 14.4923 5.40016 14.1423C4.58905 13.7923 3.8835 13.3173 3.2835 12.7173C2.6835 12.1173 2.2085 11.4118 1.8585 10.6007C1.5085 9.78954 1.3335 8.92287 1.3335 8.00065C1.3335 7.07843 1.5085 6.21176 1.8585 5.40065C2.2085 4.58954 2.6835 3.88398 3.2835 3.28398C3.8835 2.68398 4.58905 2.20898 5.40016 1.85898C6.21127 1.50898 7.07794 1.33398 8.00016 1.33398C8.92238 1.33398 9.78905 1.50898 10.6002 1.85898C11.4113 2.20898 12.1168 2.68398 12.7168 3.28398C13.3168 3.88398 13.7918 4.58954 14.1418 5.40065C14.4918 6.21176 14.6668 7.07843 14.6668 8.00065C14.6668 8.92287 14.4918 9.78954 14.1418 10.6007C13.7918 11.4118 13.3168 12.1173 12.7168 12.7173C12.1168 13.3173 11.4113 13.7923 10.6002 14.1423C9.78905 14.4923 8.92238 14.6673 8.00016 14.6673Z"
                            fill="#E5654E"
                          />
                        </svg>
                      </span>
                    );
                  }
                }}
                direction="vertical"
                items={statusItems}
              />
            </Flex>
          );
        })()}
      </span>
    </div>
  );
};

const CardItem = ({ item }) => {
  const { t } = useTranslation();
  const [detailItems, setDetailItems] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [prices, setPrices] = useState(null);
  const { exportToExcel } = useExportExcel();

  const handleDownloadClick = e => {
    e?.stopPropagation?.();

    const url = item?.su_file;
    if (!url) {
      message.error(t('Design file not available for download.'));
      return;
    }

    // Tạo thẻ a ẩn để download
    const a = document.createElement('a');
    a.href = url;

    // Đặt tên file (tuỳ bạn, có thể lấy từ URL)
    const fileNameFromUrl = url.split('/').pop()?.split('?')[0] || 'design.su';
    a.setAttribute('download', item?.item_name || fileNameFromUrl);

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleCardClick = e => {
    const url =
      ROUTER.DESIGN + '/' + item.type_design + `?design_id=${item.design_id}`;

    window.open(url, '_blank');
  };
  return (
    <>
      <div className="flex items-center gap-[24px] self-stretch border-[1px] border-solid border-outline-default-divider rounded-[8px] p-[16px]">
        <div className="flex items-center gap-[24px] grow">
          <div className="w-[60px] h-[60px] flex rounded-[4px] opacity-60 aspect-square border-[1px] border-solid border-[#EDEDED]">
            <img src={item.thumbnail ?? ''} alt="" className="object-cover" />
          </div>
          <span className="text-body-large font-semibold">
            {getValueFromString(item.item_name)}
          </span>
        </div>
        <span className="text-body-medium font-semibold">x1</span>
        <span className="text-body-medium">
          {convertForeignCurrency(
            (() => {
              return item.price_after;
            })()
          )}
        </span>
        <div className="flex items-start flex-col gap-[8px]">
          {item.data ? (
            <ButtonLink
              title={t('View details')}
              className="text-[#258FD2]"
              onClick={() => {
                try {
                  setDetailItems(item.data);
                  setImageList([item.thumbnail, item.image]);
                  setPrices({
                    total_accessory_price: item.total_accessory_price,
                    total_backsplash_price: item.total_backslash_price,
                    total_countertop_price: item.total_countertop_price,
                    total_wood_price: item.total_wood_price,
                  });
                } catch {
                  // ignore error
                }
              }}
            />
          ) : (
            <></>
          )}
          {['kitchen', 'wardrobe', 'shoe', 'bed', 'tv'].includes(
            item.type_design
          ) && item.design_id ? (
            <ButtonLink
              title={t('Open design')}
              className="text-[#258FD2]"
              onClick={handleCardClick}
            />
          ) : (
            <></>
          )}

          {(() => {
            const json = JSON.parse(item?.price_info ?? '{}');
            if (json?.dataExcel || json?.costPersistable) {
              return (
                <ButtonLink
                  title={t('Download quote')}
                  className="text-[#258FD2]"
                  onClick={() => {
                    const country_code = json.country_code ?? 'vn';

                    const dataExcel =
                      json.dataExcel?.[country_code] ||
                      json?.costPersistable?.[country_code].registry;
                    const data = convertCostDataToExcel(dataExcel);
                    if (data)
                      exportToExcel(data, item.item_name ?? '' + country_code);
                  }}
                />
              );
            }
            return null;
          })()}

          {item?.su_file ? (
            <ButtonLink
              title={t('Download Design')}
              onClick={() => {
                handleDownloadClick();
              }}
              className="text-[#258FD2]"
            />
          ) : (
            <></>
          )}
        </div>
      </div>
      <DrawerDetailModule
        open={detailItems}
        items={detailItems ?? '[]'}
        imageList={imageList}
        prices={prices}
        onClose={() => {
          setDetailItems(null);
          setImageList(null);
        }}
      />
    </>
  );
};

const CardTransaction = ({
  title,
  tag,
  methodPayment,
  paidDate,
  amount,
  paid = null,
  isRemind = false,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();

  const { reminder, order } = useSelector(state => state.adminRoom);

  return (
    <>
      <div className="flex flex-col items-start gap-[8px] self-stretch ">
        <div className="flex justify-between items-center self-stretch">
          <span className="text-title-small font-bo">{title}</span>
          {tag}
        </div>

        <div className="flex flex-col items-start gap-[4px] self-stretch">
          <div className="flex h-[24px] items-center justify-between gap-[10px] self-stretch">
            <span className="text-body-medium">{t('Payment method')}</span>
            <span className="text-body-medium">{methodPayment ?? '--'}</span>
          </div>
          <div className="flex h-[24px] items-center justify-between gap-[10px] self-stretch">
            <span className="text-body-medium">{t('Paid date')}</span>
            <span className="text-body-medium">{paidDate ?? '--'}</span>
          </div>
        </div>
        <div className={cn('flex justify-end items-center self-stretch')}>
          <span className="text-body-large font-semibold">{amount}</span>
        </div>
        {paid == null ? (
          <></>
        ) : isRemind ? (
          <div className="flex p-[8px] items-center gap-[8px] self-stretch rounded-[8px] bg-[#F2F8FD]">
            <span className="flex w-[20px] h-[20px] text-[#258FD2]">
              <Icon.ICInfo />
            </span>
            <span className="text-label-large font-semibold">
              {t('Payment due date')}
            </span>
            <span className="text-body-small truncate grow">
              {t(
                (() => {
                  if (paid === 0) {
                    return "The customer's first payment installment is now due.";
                  } else if (paid === 1) {
                    return "The customer's second payment installment is now due.";
                  } else if (paid === 2) {
                    return "The customer's last payment installment is now due.";
                  }
                })()
              )}
            </span>
            <ButtonSecondarySmall
              title={t('Send notification email')}
              disabled={reminder.isLoading}
              isLoading={reminder.isLoading}
              onClick={() => {
                dispatch(remindPayment({ id })).then(action => {
                  if (action.payload?.data) {
                    openMessageSuccess({ content: t('Successfully') });
                  }
                });
              }}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
      <Divider type="horizontal" className="m-0 !p-0" />
    </>
  );
};
